import { render } from "./CalculationItemMaterialModal.vue?vue&type=template&id=3c98991a&scoped=true"
import script from "./CalculationItemMaterialModal.vue?vue&type=script&lang=js"
export * from "./CalculationItemMaterialModal.vue?vue&type=script&lang=js"

import "./CalculationItemMaterialModal.vue?vue&type=style&index=0&id=3c98991a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c98991a"]])

export default __exports__